<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import "./assets/css/iconfont.css";
@import "./assets/css/common/common.less";
#app {
  font-family: "Overpass", "Noto Sans SC", -apple-system, BlinkMacSystemFont,
    "Helvetica Neue", Helvetica, Segoe UI, Arial, Roboto, "PingFang SC",
    "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
  color: #2c3e50;
}
body {
  margin: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue